const locale = {
  placeholder: 'Ø§Ø®ØªÙØ§Ø± Ø§ÙÙÙØª',
};

export default locale;
